/**
 * Created by Administrator on 2019/2/14.
 */
import activeList from './list.vue';
import activeApply from './apply.vue';
import activeApprove from './activeApprove.vue';
import activeDetail from './activeDetail.vue';
import activeRemark from './activeRemark.vue';

import activeReportList from './reportList.vue';
import reportApply from './reportApply.vue';
import reportDetail from './reportDetail.vue';
import reportApprove from './reportApprove.vue';

export default {
  activeList,
  activeApply,
  activeApprove,
  activeDetail,
  activeRemark,

  activeReportList,
  reportApply,
  reportDetail,
  reportApprove
}



// WEBPACK FOOTER //
// ./src/components/active/index.js